import { render, staticRenderFns } from "./GetInputDataDetails.vue?vue&type=template&id=152ab920"
import script from "./GetInputDataDetails.vue?vue&type=script&lang=js"
export * from "./GetInputDataDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports